import { lazy } from "react";
import { Route } from "react-router-dom";
import { Home } from "../pages/Home";

/**
 * Groupe de routes PUBLIQUES (17) — SITE_SPEC §3.1.
 * L'Accueil (`Home`) reste la page de référence stylée de la coquille ; les autres sont
 * des stubs lazy-chargés que les agents Pages remplaceront.
 */

const Vote = lazy(() => import("../pages/public/Vote"));
const Boutique = lazy(() => import("../pages/public/Boutique"));
const Carte = lazy(() => import("../pages/public/Carte"));
const Classements = lazy(() => import("../pages/public/Classements"));
const Armurerie = lazy(() => import("../pages/public/Armurerie"));
const PublicProfile = lazy(() => import("../pages/public/PublicProfile"));
const Guildes = lazy(() => import("../pages/public/Guildes"));
const GuildeDetail = lazy(() => import("../pages/public/GuildeDetail"));
const ForumHall = lazy(() => import("../pages/public/forum/ForumHall"));
const ForumCategory = lazy(() => import("../pages/public/forum/ForumCategory"));
const ForumThread = lazy(() => import("../pages/public/forum/ForumThread"));
const ForumNewThread = lazy(() => import("../pages/public/forum/ForumNewThread"));
const Signalements = lazy(() => import("../pages/public/Signalements"));
const SuggestionsHall = lazy(() => import("../pages/public/suggestions/SuggestionsHall"));
const SuggestionNew = lazy(() => import("../pages/public/suggestions/SuggestionNew"));
const SuggestionDetail = lazy(() => import("../pages/public/suggestions/SuggestionDetail"));
const Monde = lazy(() => import("../pages/public/Monde"));
const Evenements = lazy(() => import("../pages/public/Evenements"));
const Statut = lazy(() => import("../pages/public/Statut"));
const Patchnotes = lazy(() => import("../pages/public/Patchnotes"));
const Reglement = lazy(() => import("../pages/public/Reglement"));
const ServerShop = lazy(() => import("../pages/public/ServerShop"));
const GuideHub = lazy(() => import("../pages/public/guide/GuideHub"));
const GuideDetail = lazy(() => import("../pages/public/guide/GuideDetail"));
const WikiHome = lazy(() => import("../pages/public/WikiHome"));
const WikiItems = lazy(() => import("../pages/public/WikiItems"));
const WikiClasses = lazy(() => import("../pages/public/WikiClasses"));
const WikiEnchants = lazy(() => import("../pages/public/WikiEnchants"));
const WikiMetiers = lazy(() => import("../pages/public/WikiMetiers"));
const WikiMobs = lazy(() => import("../pages/public/WikiMobs"));
const WikiZones = lazy(() => import("../pages/public/WikiZones"));
const WikiDonjons = lazy(() => import("../pages/public/WikiDonjons"));
const WikiCrafts = lazy(() => import("../pages/public/WikiCrafts"));
const WikiCuisine = lazy(() => import("../pages/public/WikiCuisine"));
const WikiRecolte = lazy(() => import("../pages/public/WikiRecolte"));
const WikiRanks = lazy(() => import("../pages/public/WikiRanks"));
const WikiRng = lazy(() => import("../pages/public/WikiRng"));
const WikiEntry = lazy(() => import("../pages/public/WikiEntry"));

/** Éléments de route publics (à insérer sous <AppLayout>). `index` = Accueil. */
export const publicRoutes = (
  <>
    <Route index element={<Home />} />
    <Route path="vote" element={<Vote />} />
    <Route path="boutique" element={<Boutique />} />
    <Route path="carte" element={<Carte />} />
    <Route path="classements" element={<Classements />} />
    <Route path="armurerie" element={<Armurerie />} />
    <Route path="joueur/:name" element={<PublicProfile />} />
    <Route path="guildes" element={<Guildes />} />
    <Route path="guildes/:name" element={<GuildeDetail />} />
    <Route path="forum" element={<ForumHall />} />
    <Route path="forum/nouveau" element={<ForumNewThread />} />
    <Route path="forum/sujet/:id" element={<ForumThread />} />
    <Route path="forum/:categorie" element={<ForumCategory />} />
    <Route path="signalements" element={<Signalements />} />
    <Route path="suggestions" element={<SuggestionsHall />} />
    <Route path="suggestions/nouveau" element={<SuggestionNew />} />
    <Route path="suggestions/:id" element={<SuggestionDetail />} />
    <Route path="monde" element={<Monde />} />
    <Route path="evenements" element={<Evenements />} />
    <Route path="statut" element={<Statut />} />
    <Route path="patchnotes" element={<Patchnotes />} />
    <Route path="reglement" element={<Reglement />} />
    <Route path="shop-serveur" element={<ServerShop />} />
    <Route path="guide" element={<GuideHub />} />
    <Route path="guide/:id" element={<GuideDetail />} />
    <Route path="wiki" element={<WikiHome />} />
    <Route path="wiki/patchnotes" element={<Patchnotes />} />
    <Route path="wiki/reglement" element={<Reglement />} />
    <Route path="wiki/items" element={<WikiItems />} />
    <Route path="wiki/classes" element={<WikiClasses />} />
    <Route path="wiki/enchants" element={<WikiEnchants />} />
    <Route path="wiki/metiers" element={<WikiMetiers />} />
    <Route path="wiki/mobs" element={<WikiMobs />} />
    <Route path="wiki/zones" element={<WikiZones />} />
    <Route path="wiki/donjons" element={<WikiDonjons />} />
    <Route path="wiki/crafts" element={<WikiCrafts />} />
    <Route path="wiki/cuisine" element={<WikiCuisine />} />
    <Route path="wiki/recolte" element={<WikiRecolte />} />
    <Route path="wiki/ranks" element={<WikiRanks />} />
    <Route path="wiki/rng" element={<WikiRng />} />
    <Route path="wiki/:cat/:id" element={<WikiEntry />} />
  </>
);
